<template>
  <div id="app">
    <div class="menu-box">
      <div class="menu-item">
        <div @click="choiceMenu(0)" :class="(menuIndex === 0) ? 'choice' : ''">หน้าแรก</div>
        <div @click="choiceMenu(1)" :class="(menuIndex === 1) ? 'choice' : ''">ขั้นตอนการใช้งาน</div>
        <div @click="choiceMenu(2)" :class="(menuIndex === 2) ? 'choice' : ''">จุดเด่นของเรา</div>
        <div @click="choiceMenu(4)" :class="(menuIndex === 4) ? 'choice' : ''">เกี่ยวกับเรา</div>
        <div @click="choiceMenu(5)" :class="(menuIndex === 5) ? 'choice' : ''">นโยบายความเป็นส่วนตัว</div>
        <div @click="choiceMenu(6)" :class="(menuIndex === 6) ? 'choice' : ''">ติดต่อเรา</div>
      </div>
    </div>
    <div class="banner-box" id='home' ref="home">
      <img src="./assets/banner.png" class="banner">
      <div class="app_name">
        <div class="title">ยืมอย่างมีความสุข</div>
        <div class="title-content">
          ชื่อแอปพลิเคชัน:ยืมอย่างมีความสุข <br>
          คำบรรยาย: สินเชื่อดอกต่ำ<br>
          คำอธิบายแบบย่อ: 0 ค้ำประกัน 0 สินเชื่อจำนอง

        </div>
        <!-- <a href="https://play.google.com/store/apps/details?id=com.gotoloan.cash">
          <img src="./assets/Google play.png" class="google-play">
        </a> -->
      </div>
    </div>
    <div class="step-box" id='step' ref="step">
      <div class="title">ขั้นตอนการใช้งาน</div>
      <div class="step-content">
        <img src="./assets/product.png" class="step-img">
        <div class="step-text-box">
          <p>1. ดาวน์โหลดยืมอย่างมีความสุขยืมอย่างมีความสุขจาก Google Play และเข้าสู่ระบบและลงทะเบียนบัญชีส่วนตัว</p>
          <p>2. กรอกข้อมูลพื้นฐานและส่งใบสมัคร</p>
          <p>3. รอการตรวจสอบข้อมูล เงินกู้จะเข้าบัญชีธนาคารของคุณโดยตรงหลังจากผ่านการตรวจสอบ</p>
        </div>
      </div>
    </div>
    <div class="product" id="product" ref="product">
      <div class="title">จุดเด่นของเรา</div>
      <div class="product-content">

        <div class="product-item-text">
          <div>1： อัตราดอกเบี้ยต่ำ: ยืมอย่างมีความสุขยืมอย่างมีความสุข เป็นแอปสินเชื่อออนไลน์ที่มีอัตราดอกเบี้ยต่ำมาก ค่าธรรมเนียมการจัดการที่โปร่งใส ทำให้ผู้ใช้สามารถยืมได้อย่างสบายใจ คุ้มค่าแก่ความไว้วางใจของผู้ใช้</div>
          <div>2： ประสิทธิภาพสูง: กระบวนการอนุมัติที่เร็วขึ้น การดำเนินการออนไลน์ที่บริสุทธิ์</div>
          <div>3： ทันเวลา: 7*24 บริการลูกค้าทุกที่ทุกเวลา</div>
          <div>4： ความสะดวกสบาย: ด้วยการออกแบบและอินเทอร์เฟซแบบโต้ตอบที่เข้าใจง่าย สามารถสอบถามความคืบหน้าในการสมัครขอสินเชื่อได้แบบเรียลไทม์ผ่านโทรศัพท์มือถือ</div>
        </div>
        <img src="./assets/product.png" class="product-img">
      </div>
    </div>

    <div class="about" id='about' ref="about">
      <div class="title">เกี่ยวกับเรา</div>
      <div class="about-content">
        ในปี 2560 เราเข้าสู่ตลาดแรงงานด้วยกันและตระหนักว่าการหารายได้และการใช้จ่ายเงินเดือนแรกนั้นพิเศษมากและฉันเชื่อว่าคุณมีความรู้สึกเช่นกัน อย่างไรก็ตาม การบริโภคจำนวนมากในบางครั้งทำให้เราสูญเสีย และเงินเดือนอยู่ไกลจากระดับการบริโภคของเราที่น่าพอใจ เราหวังว่าจะมีแพลตฟอร์มซอฟต์แวร์ที่รวดเร็วและสะดวกสบายที่จะช่วยให้เราฝ่าฟันอุปสรรคและรับประกันเสรีภาพในความมั่งคั่งของเรา

        <br> ดังนั้นเราจึงตั้งทีมเพื่อแก้ปัญหานี้ด้วยตัวเองก่อน จากนั้นเราก็รู้ทันทีว่าคนอื่นมีปัญหาคล้ายกันมากกว่า ดังนั้น ยืมอย่างมีความสุขยืมอย่างมีความสุขพัฒนาเพื่อแก้ปัญหาทางการเงินส่วนบุคคลมากขึ้นและเปลี่ยนเป็นแพลตฟอร์มปัจจุบัน:

      </div>
    </div>

    <div class="del-data-box">
      <div class="tel-box" v-if="steps == 1">
        <div class="tip">การใช้ฟังก์ชันการลบข้อมูลเพื่อความปลอดภัยของข้อมูลของคุณ คุณต้องยืนยันตัวตนของคุณ</div>
        <div class="title">กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ</div>
        <input v-model="mobile" type="text" class="tel-in" placeholder="กรุณากรอกหมายเลขโทรศัพท์">
        <input v-model="password" type="password" class="tel-pa" placeholder="กรุณากรอกรหัสผ่านสำหรับแอป">
        <div class="btn" @click="delSearch">ขั้นตอนถัดไป</div>
      </div>
      <div class="tel-box" v-else-if="steps == 2">
        <div class="กล่องข้อความ">
          เรียนผู้ใช้
          <br> สวัสดี! ขอบคุณมากครับที่เลือกใช้แอพ ได้บาทง่ายๆ
          <br> ก่อนที่จะสมัครลบบัญชี โปรดตรวจสอบให้แน่ใจว่าคำสั่งซื้อของคุณทั้งหมดได้รับการชำระแล้ว และไม่มีคำสั่งซื้อที่อยู่ระหว่างการตรวจสอบ โปรดทราบว่าเมื่อลบบัญชีแล้ว จะไม่สามารถกู้คืนข้อมูลได้ โปรดยืนยันอย่างรอบคอบก่อนใช้งาน แอพนี้ไม่รับผิดชอบต่อความสูญเสียใด ๆ ที่เกิดขึ้นต่อทรัพย์สินส่วนบุคคล
          <br> หากคุณยืนยันว่าต้องการลบข้อมูลของคุณ โปรดคลิกปุ่มด้านล่าง
        </div>
        <div class="btn" @click="candelete">ยืนยันการลบ</div>
      </div>

      <div class="tel-box" v-else-if="steps == 3">
        <div class="title">โปรดป้อนรหัสยืนยันเพื่อยืนยันตัวตนของคุณ</div>
        <div class="iump-box">
          <input v-model="code" type="text" class="car-in tel-in" placeholder="กรุณากรอกรหัสยืนยัน 4 หลัก" />
          <div class="count-btn" @click="Reenviar"> {{ Time > 0 ? Time : 'ส่งอีกครั้ง' }} </div>
        </div>
        <div class="btn" @click="doDelete">ตกลง</div>
      </div>

      <div class="tel-box del-box" v-else-if="steps == 4">
        <img src="./assets/del.png" alt="">
        <p>ข้อมูลของคุณถูกลบแล้ว!</p>
      </div>
      <div class="tel-box" v-else-if="steps == 5">
        <div class="title">การยืนยันบัตรประจำตัวประชาชน</div>
        <input v-model="idcard" type="text" class="tel-in" placeholder="กรุณากรอกบัตรประจำตัวประชาชนของคุณ">
        <div class="btn" @click="verifyIdCard">กำลังตรวจสอบ</div>
      </div>
    </div>

    <div class="privacy" id='privacy' ref="privacy">
      <div class="title"> นโยบายความเป็นส่วนตัว</div>
      <div class="privacy-content " :class="(isMore) ? 'bottomhig' : 'maxhight'">
        <br> นโยบายความเป็นส่วนตัวของยืมอย่างมีความสุขจัดทำขึ้นเพื่อให้ผู้ใช้เข้าใจว่าเรารวบรวม ประมวลผล และปกป้องข้อมูลและข้อมูลส่วนบุคคลของผู้ใช้อย่างไรเมื่อใช้ผลิตภัณฑ์และบริการของเราผ่าน ยืมอย่างมีความสุข
        <br> ผู้พัฒนาแอปพลิเคชั่นคือGalih Nurjamanโดยการใช้บริการของยืมอย่างมีความสุขผู้ใช้ตกลงที่จะรวบรวมเปิดเผย และนโยบายการใช้งานอื่นๆของข้อมูลผู้ใช้ที่อธิบายไว้ในนโยบายความเป็นส่วนตัวนี้เราขออนุญาตจากคุณเพื่อให้ข้อมูลต่อไปนี้ เป็นผู้พัฒนาแอปพลิเคชันนี้ หากคุณต้องการทราบเกี่ยวกับข้อมูลเพิ่มเติมเกี่ยวกับแอปพลิเคชันนี้ สามารถติดต่อมาหาเราทางอีเมลได้ที่ อีเมล: afwegfhrtwerw@gmail.com
        <h3>ต่อไปนี้คือการอนุญาตและข้อมูลที่เก็บรวบรวมที่เราจะต้องได้รับโดยได้รับอนุมัติและอนุญาตล่วงหน้า:</h3>
        <br> 1.ข้อมูลส่วนบุคคลของผู้ใช้: เมื่อผู้ใช้สมัครสินเชื่อ เราต้องการให้ผู้ใช้กรอกข้อมูลส่วนบุคคลของตน ได้แก่ ชื่อ วันเกิด เพศ บัตรประจำตัวประชาชน ข้อมูลการทำงาน ข้อมูลครอบครัว ฯลฯ ใช้เพื่อช่วยผู้ใช้สมัครขอสินเชื่อและประเมินอันดับเครดิตของผู้ใช้
        <br> 2.ข้อมูล SMS: เพื่อความปลอดภัยของเงินกู้ เมื่อผู้ใช้งานขอกู้เงิน ยืมอย่างมีความสุข จำเป็นต้องเข้าถึงข้อมูล SMS ของผู้ใช้งาน (รวมถึงชื่อผู้ส่ง เนื้อหา และสถานะการอ่าน) เพื่อประเมินความสามารถในการกู้และป้องกันการฉ้อโกง ยืมอย่างมีความสุข จะเก็บข้อมูลนี้เฉพาะเมื่อได้รับอนุญาตจากผู้ใช้งานอย่างชัดเจนเท่านั้น ข้อมูล SMS ที่เก็บมาจะถูกคัดกรอง และเฉพาะข้อมูลที่จำเป็นจริง ๆ จะถูกเข้ารหัสและอัปโหลดไปยัง https://ac.hypphnaowen.com/ เพื่อจัดเก็บ ยืมอย่างมีความสุข ขอรับรองว่าจะไม่แชร์ข้อมูลดังกล่าวกับบุคคลที่สามเด็ดขาด

        <br> 3.ข้อมูลรายชื่อผู้ติดต่อ: เพื่อปกป้องความปลอดภัยทางการเงินของทั้งสองฝ่าย เมื่อคุณใช้ ยืมอย่างมีความสุข เพื่อสมัครขอสินเชื่อ ยืมอย่างมีความสุข จำเป็นต้องเลือกข้อมูลติดต่อในกรณีฉุกเฉินในสมุดที่อยู่ของคุณ ซึ่งรวมถึง: หมายเลขติดต่อ ชื่อผู้ติดต่อ ความสัมพันธ์ เพื่อป้องกันความเสี่ยงจากการฉ้อโกง และยืนยันอันดับเครดิตของคุณ และทำให้การสื่อสารราบรื่น ข้อมูลที่รวบรวมจะถูกอัปโหลดอย่างปลอดภัยไปยังศูนย์ความปลอดภัย https://ac.hhypphnaowen.com/ สำหรับพื้นที่เก็บข้อมูลที่เข้ารหัส และจะไม่ถูกแชร์กับบุคคลที่สาม ยืมอย่างมีความสุข ไม่สามารถเข้าถึงข้อมูลรายชื่อผู้ติดต่อของคุณได้ จะเข้าถึงได้เฉพาะข้อมูลผู้ติดต่อฉุกเฉินที่คุณเลือกอัปโหลดเท่านั้น และทุกการดำเนินการจะทำได้ก็ต่อเมื่อได้รับอนุญาตจากคุณอย่างชัดเจนเท่านั้น

        <br> 4. การอนุญาตใช้กล้อง: จุดประสงค์ในการใช้กล้องคือการตรวจจับตัวตนที่แท้จริงของผู้ใช้ และเราจะปกป้องข้อมูลของผู้ใช้อย่างเคร่งครัดทั้งนี้เพื่อการทำงานที่ราบรื่นของแอปพลิเคชั่นและเว็บไซต์เพื่อให้ยืมอย่างมีความสุข สามารถเข้าถึงการอนุญาตของกล้องได้
        <br> 5. ข้อมูลอุปกรณ์: เพื่อเก็บรวบรวมข้อมูล เช่น ยี่ห้อ รุ่น IP และข้อมูลอุปกรณ์อื่นๆ
        <br> 6. ข้อมูลที่ตั้งทางภูมิศาสตร์ :เมื่อผู้ใช้งานใช้แอปของเรา ยืมอย่างมีความสุข จะเข้าถึงข้อมูลตำแหน่งที่ตั้งโดยประมาณของผู้ใช้งาน เพื่อปรับปรุงคุณภาพการให้บริการและจับคู่บริการลูกค้าที่เหมาะสมตามตำแหน่งของผู้ใช้งานได้อย่างมีประสิทธิภาพ

        <br> 7. ข้อมูลบัญชีโซเชียล: รวมถึงบัญชีเฟสบุ๊ค บัญชี gmail อีเมล ฯลฯ ที่ใช้ในการยืนยันตัวตนของผู้กู้และติดต่อผู้ขอ
        <br> 8.รายการแอพที่ติดตั้ง: เมื่อผู้ใช้ยืมเงินโดยใช้ ยืมอย่างมีความสุข ยืมอย่างมีความสุข จะต้องได้รับและอัปโหลดรายการผู้ใช้ของแอปพลิเคชันที่ติดตั้ง (รวมถึง: ชื่อแอปพลิเคชันที่ติดตั้ง ชื่อแพ็คเกจ เวลาการติดตั้ง เวลาอัปเดต ฯลฯ) ใช้สำหรับการสร้างโปรไฟล์ผู้ใช้และการวิเคราะห์การฉ้อโกงเพื่อป้องกันการฉ้อโกงทางการเงิน การฉ้อโกง. ข้อมูลที่รวบรวมจะถูกส่งไปยัง https://ac.hhypphnaowen.com/ โดยใช้เทคโนโลยีความปลอดภัยที่เข้ารหัส ยืมอย่างมีความสุขเคารพและปกป้องความเป็นส่วนตัวของผู้ใช้ และจะไม่แชร์ข้อมูลดังกล่าวกับบุคคลที่สามโดยไม่ได้รับอนุญาต
        <br> 9.รูปภาพ: เมื่อผู้ใช้ใช้ฟังก์ชันที่เกี่ยวข้องกับการอัปโหลดรูปภาพ (เช่น การรายงานปัญหาไปยังฝ่ายบริการลูกค้า ฯลฯ) ยืมอย่างมีความสุข จะได้รับข้อมูลรูปภาพที่ระบุโดยผู้ใช้ โปรดทราบ: เราไม่ได้รับรูปภาพของผู้ใช้ อัลบั้มเฉพาะภาพที่ผู้ใช้เลือกเท่านั้น ภาพที่รวบรวมจะถูกเข้ารหัสและอัปโหลดไปที่ https://ac.hhypphnaowen.com/ และจะไม่ถูกแชร์กับบุคคลที่สาม
        <br> 10.รหัสโฆษณา Google (GAID): เราจำเป็นต้องได้รับรหัสโฆษณาของผู้ใช้เพื่อแนะนำผลิตภัณฑ์ที่เหมาะกับผู้ใช้มากขึ้น


        <h3>วัตถุประสงค์ของเราในการรวบรวมข้อมูลส่วนบุคคล</h3>
        <br>ในบริบทของการใช้บริการอื่น ๆ ให้ให้บริการตามเงื่อนไขการใช้งาน ข้อบังคับและข้อตกลง
        <br>ประเมินคำขอของคุณและตรวจสอบมาตรฐานที่จำเป็นในการดำเนินการตามคำขอของคุณ
        <br>จัดเตรียมสิ่งอำนวยความสะดวกสิ่งอำนวยความสะดวกและข้อมูลที่คุณต้องการเกี่ยวกับบริการบนแอปมือถือของเรา
        <br>ตามข้อกำหนดทางกฎหมายที่เกี่ยวข้องของข้อตกลงนี้ยืมอย่างมีความสุขขายให้เช่าแบ่งปันหรือแลกเปลี่ยนข้อมูลส่วนบุคคลของผู้ใช้กับบุคคลที่สาม
        <br>หลังจากที่คุณตกลง เราจะใช้ข้อมูลส่วนบุคคลตามนโยบายความเป็นส่วนตัวนี้ได้

        <h3>วิธีที่เราใช้ข้อมูลส่วนบุคคลของผู้ใช้</h3>
        <br>ให้บริการตามเงื่อนไขการใช้งานหรือข้อตกลงการบริการ
        <br>ตามกฎหมายและระเบียบที่เกี่ยวข้องซึ่งใช้ข้อตกลงนี้เป็นหลัก ยืมอย่างมีความสุขที่จะให้ ขาย ให้เช่า แบ่งปันหรือแลกเปลี่ยนข้อมูลส่วนบุคคลของผู้ใช้กับบุคคลที่สามที่ไม่เกี่ยวข้อง

        <h3>ความเป็นส่วนตัวของเด็ก</h3>
        <br>บริการเหล่านี้ไม่เหมาะสำหรับผู้ที่มีอายุต่ำกว่า 13 ปี เราไม่ได้รวบรวมข้อมูลส่วนบุคคลที่สามารถระบุตัวบุคคลได้อย่างรู้เท่าทัน หากเราพบว่าเด็กอายุต่ำกว่า 13 ปีให้ข้อมูลส่วนบุคคลแก่เรา เราจะลบข้อมูลนั้นออกจากเซิร์ฟเวอร์ของเราทันที หากคุณเป็นพ่อแม่หรือผู้ปกครองและรู้ว่าบุตรหลานของคุณได้ให้ข้อมูลส่วนบุคคลแก่เรา โปรดติดต่อเราเพื่อให้เราสามารถดำเนินการที่จำเป็นเพื่อปกป้องข้อมูลของผู้เยาว์ได้
        <h3>การเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้</h3>
        <br>เราอาจปรับปรุงนโยบายความเป็นส่วนตัวของเราเป็นครั้งคราว ดังนั้น ขอแนะนำให้คุณตรวจสอบหน้านี้เป็นประจำเพื่อดูการเปลี่ยนแปลงใดๆ เราจะแจ้งให้คุณทราบถึงการเปลี่ยนแปลงใด ๆ โดยการโพสต์นโยบายความเป็นส่วนตัวใหม่ในหน้านี้ การเปลี่ยนแปลงเหล่านี้จะมีผลและมีผลทันทีหลังจากโพสต์ในหน้านี้
        <h3>การแบ่งปันข้อมูลส่วนบุคคล</h3>
        <br> เรารับประกันว่าข้อมูลส่วนบุคคลของผู้ใช้หรือข้อมูลจะไม่ถูกขาย โอน หรือยืมโดยไม่ได้รับอนุญาตจากผู้ใช้
        <br> ข้อมูลส่วนบุคคลของผู้ใช้จะถูกเข้ารหัสและส่งไปยัง https://ac.hhypphnaowen.com/ เราจะไม่ขาย โอน หรือยืมข้อมูลส่วนบุคคลของผู้ใช้

        <h3>การจัดเก็บข้อมูล การเก็บรักษา และการลบ</h3>
        <br>ข้อมูลส่วนบุคคลของผู้ใช้และข้อมูลอื่น ๆ ที่เกี่ยวข้องจะถูกส่งและจัดเก็บผ่านเทคโนโลยีการเข้ารหัส (SSL) และป้องกันด้วยรหัสผ่าน ในขณะเดียวกัน เรายังมีกลไกป้องกันเสียงเพื่อปกป้องข้อมูลส่วนบุคคลของผู้ใช้จากการโจมตีที่เป็นอันตราย ตราบใดที่บัญชีของผู้ใช้ยังคงใช้งานอยู่ เราจะเก็บรักษาข้อมูลส่วนบุคคลและลบออกตามกฎหมายและระเบียบข้อบังคับที่บังคับใช้
        <h3>การรับรองความปลอดภัย</h3>
        <br>เรารับประกันว่าข้อมูลทั้งหมดที่เรารวบรวมจะถูกใช้เพื่อเพิ่มประสิทธิภาพแอปพลิเคชันหรือบริการเท่านั้น ตรวจสอบตัวตนของผู้ใช้ ลดความเสี่ยงของการฉ้อโกงข้อมูลประจำตัว ประเมินความเสี่ยงด้านเครดิต และใช้สำหรับการวิเคราะห์คะแนนเครดิต การวิเคราะห์เชิงปริมาณและสถิติ การควบคุมด้านกฎระเบียบ การฉ้อโกง การป้องกันและกิจกรรมทางอาญาอื่น ๆ
        <h3>ติดต่อเรา</h3>
        <br> หากคุณมีคำถามใดๆ เกี่ยวกับนโยบายความเป็นส่วนตัวนี้ คุณสามารถติดต่อเราด้วยวิธีต่อไปนี้:
        <br> ที่อยู่อีเมล: afwegfhrtwerw@gmail.com

      </div>
      <div class="get-more" @click="isMore = true" v-if="!isMore">
        <img src="./assets/get-more.png" alt="">
      </div>
    </div>


    <div class="footer" id='footer' ref="footer">
      <div class="title">ติดต่อเรา </div>
      <div class="footer-content">
        <div class="mail-box">
          <img src="./assets/mail.png" class="mail-img">
          <div class="mail">afwegfhrtwerw@gmail.com</div>
        </div>
        <div class="address-box">
          <img src="./assets/address.png" class="address-img">
          <div class="address">
            349 SJ Infinite One Business Complex ชั้น 29 และ 30 ถนนวิภาวดีรังสิต แขวงจอมพล เขตจตุจักร กรุงเทพมหานคร 10900
          </div>
        </div>
      </div>
      <p class="bottom-text">© Copyright 2022. ยืมอย่างมีความสุข all Rights Reserved.</p>
    </div>

    <div class="flex-box" v-if="msgDlg">
      <div class="msg-box">
        <div class="msg">
          <img src="./assets/title-err.png" class="err-img">
          {{ msg }}
        </div>
        <img src="./assets/close.png" class="close" @click="msgDlg = false">
      </div>
    </div>

  </div>
</template>

<script>
import * as api from "@/api/api";
export default {
  name: 'App',
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      showMenu: false,
      mobile: '',
      password: '',
      code: '',
      msgDlg: false,
      msg: '',
      steps: 1,
      infoData: {},
      Time: 0,
      idcard: '',
      verifyIDCard: '',
    }
  },
  methods: {
    choiceMenu(index) {
      this.menuIndex = index
      switch (index) {
        case 0: document.getElementById("home").scrollIntoView(); break;
        case 1: document.getElementById("step").scrollIntoView(); break;
        case 2: document.getElementById("product").scrollIntoView(); break;
        case 3: document.getElementById("user").scrollIntoView(); break;
        case 4: document.getElementById("about").scrollIntoView(); break;
        case 5: document.getElementById("privacy").scrollIntoView(); break;
        case 6: document.getElementById("footer").scrollIntoView(); break;
        default:
          break;
      }
    },
    delSearch() {
      let data = {
        mobile: this.mobile,
        password: this.password
      }
      if (!this.mobile) {
        this.msg = 'หมายเลขโทรศัพท์มือถือต้องไม่เว้นว่าง'
        this.msgDlg = true
        return
      }
      if (!this.password) {
        this.msg = 'รหัสผ่านต้องไม่เว้นว่าง'
        this.msgDlg = true
        return
      }

      let loding = this.$loading.show({})
      api.delInfoSearch(data).then(res => {
        loding.hide()
        this.infoData = res.data
        this.steps = 2
      }).catch(e => {
        loding.hide()
        this.msg = e.message
        this.msgDlg = true
      })
    },
    candelete() {
      let data = {
        user_id: this.infoData.user_id
      }
      let loding = this.$loading.show({})
      api.delInfoCanDelete(data).then(res => {
        loding.hide()
        if (res.data.idcard) {
          this.verifyIDCard = res.data.idcard
          this.steps = 5
        } else {
          this.steps = 3
          this.Reenviar()
        }
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    verifyIdCard() {
      console.log(this.verifyIDCard);
      if (this.verifyIDCard == this.idcard) {
        this.steps = 3
        this.Reenviar()
      } else {
        this.msgDlg = true
        this.msg = 'ป้อนบัตรประจำตัวไม่ถูกต้องและการตรวจสอบล้มเหลว'
      }
    },
    Reenviar() {
      if (this.Time > 0) {
        return
      }
      this.Countdown(60)
      let data = {
        mobile: this.mobile
      }
      let loding = this.$loading.show({})
      api.delInfoSms(data).then(res => {
        loding.hide()
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    doDelete() {
      let loding = this.$loading.show({})
      let data = {
        mobile: this.mobile,
        code: this.code,
        user_id: this.infoData.user_id
      }
      api.delInfoDoDelete(data).then(res => {
        loding.hide()
        this.steps = 4
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    Countdown(time) {
      this.Time = time
      if (time <= 0) {
        return
      }

      setTimeout(() => {
        this.Countdown(time - 1)
      }, 1000);
    }
  }
}
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
  padding: 0;
  width: 100%;
  font-family: Microsoft YaHei, Hiragino Sans GB, sans-serif;
}

li {
  list-style-type: none;
  list-style-position: outside;
}
</style>

<style lang="less" scoped>
#app {
  font-family: Microsoft YaHei, Hiragino Sans GB, sans-serif;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  line-height: 1.8;

  .menu-box {
    position: fixed;
    display: flex;
    left: 0px;
    top: 0px;
    right: 0px;
    z-index: 100;
    height: 100px;
    color: #333;
    justify-content: space-between;
    align-items: center;
    padding: 0px 300px;
    font-weight: bolder;
    background: rgb(255, 255, 255);

    .menu-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    div {
      padding: 0px 20px;
      height: 40px;
      line-height: 40px;
      cursor: pointer;
    }

    .log-box {
      margin-right: 100px;
      display: flex;

      img {
        width: 40px;
      }

      span {
        margin-left: 20px;
      }
    }

    .choice {
      background-color: #fffb04;
      border-radius: 20px;
      color: rgb(26, 102, 201);
    }
  }

  .banner-box {
    position: relative;

    .banner {
      width: 100%;
    }

    .app_name {
      font-size: 60px;
      color: #ffffff;
      text-align: left;
      position: absolute;
      left: 196px;
      top: 351px;

      .white {
        width: 72px;
        height: 18px;
        background-color: #ffffff;
        margin-top: 56px;
      }

      .title-content {
        font-size: 30px;
        // color: #ffffff;
        text-align: left;
        line-height: 60px;
        width: 784px;
        margin-top: 56px;
      }

      .google-play {
        width: 376px;
        margin-top: 50px;
      }
    }
  }

  .step-box {
    padding-top: 155px;
    overflow: hidden;

    .title {
      text-align: center;
      position: relative;
      font-weight: 500;
      font-size: 30px;
      color: #333333;
    }

    .step-content {
      overflow: hidden;
      margin-top: 79px;
      padding: 0px 340px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 20px;
      flex-wrap: wrap;

      .step-img {
        width: 430px;
      }

      .step-text-box {
        font-size: 18px;
        color: #333333;
        text-align: left;

        p {
          line-height: 50px;
        }
      }
    }
  }

  .product {
    font-size: 46px;
    margin-top: 340px;
    width: 100%;
    overflow: hidden;
    position: relative;

    .title {
      text-align: center;
      position: relative;
      font-weight: 500;
      margin-top: 100px;
    }

    .product-content {
      padding: 0px 250px;
      margin-top: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .product-item-text {
        margin-right: 20px;

        div {
          font-size: 20px;
          color: #333333;
          text-align: left;
          line-height: 50px;
        }
      }

      .product-img {
        width: 397px;
      }
    }
  }

  .user {
    font-size: 46px;
    overflow: hidden;
    padding-top: 322px;

    .title {
      text-align: center;
      position: relative;
      font-weight: 500;
    }

    .user-content {
      display: flex;
      padding: 0px 250px;
      justify-content: space-between;
      align-items: center;
      margin-top: 200px;

      .user-img {
        width: 290px;
      }

      .user-text-box {
        font-size: 28px;
        text-align: left;
        width: 1000px;
        line-height: 80px;
      }
    }
  }

  .about {
    font-size: 38px;
    margin-top: 184px;
    background: #7765ff;
    // background: url('./assets/us-bg.png');
    background-size: 100% 100%;
    padding: 100px 0px;
    color: #ffffff;

    .title {
      text-align: center;
      position: relative;
      font-weight: 500;
    }

    .about-content {
      margin-top: 68px;
      padding: 0px 150px;
      font-size: 20px;
      text-align: left;
      line-height: 60px;
    }
  }

  .privacy {
    font-size: 46px;
    padding: 50px 168px 0px 168px;
    // background-color: rgba(0, 0, 0, 0.8);
    // color: #fff;
    // border-bottom: 1px #fff dashed;
    margin-top: 200px;

    .title {
      text-align: center;
      position: relative;
      font-size: 38px;
      font-weight: 500;
    }

    .privacy-content {
      margin-top: 130px;
      text-align: left;
      font-size: 20px;

      h3 {
        // margin-top: 20px;
        color: #7765ff;
      }
    }

    .maxhight {
      max-height: 490px;
      overflow: hidden;
    }

    .bottomhig {
      padding-bottom: 100px;
    }

    .get-more {
      margin-top: 20px;
      opacity: 0.3;

      img {
        width: 46px;
      }
    }
  }

  .footer {
    padding: 70px 150px 106px 150px;
    font-size: 38px;
    color: #ffffff;
    // margin-top: 140px;
    // background: #7516e7;
    background-color: rgba(0, 0, 0, 0.8);
    position: relative;

    .title {
      text-align: center;
      position: relative;
      font-weight: 500;
    }

    .footer-content {
      padding: 0px 200px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 88px;

      .mail-box {
        max-width: 45%;
        display: flex;
        align-items: center;

        .mail-img {
          width: 33px;
        }

        .mail {
          font-size: 18px;
          color: #ffffff;
          margin-left: 17px;
        }
      }

      .address-box {
        display: flex;
        align-items: center;

        .address-img {
          width: 28px;
        }

        .address {
          width: 700px;
          font-size: 18px;
          color: #ffffff;
          margin-left: 17px;
          text-align: left;
        }
      }
    }

    .bottom-text {
      font-size: 16px;
      text-align: center;
      margin-top: 50px;
    }
  }

  .del-data-box {
    background: #F5F5F5;
    padding: 100px 560px;

    .tel-box {
      min-height: 155px;
      background: #FFFFFF;
      padding: 40px 150px;
      display: flex;
      flex-direction: column;
      align-items: self-start;

      .tip {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
      }

      .title {
        font-size: 24px;
        font-weight: 400;
        color: #333333;
        margin-top: 24px;
      }

      .tel-in,
      .tel-pa {
        width: 452px;
        height: 60px;
        border-radius: 5px;
        border: 1px solid #EFEFEF;
        margin-top: 14px;
        padding: 0px 24px;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 60px;
      }

      .iump-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 24px;
        width: 500px;
      }

      .car-in {
        width: 302px;
        margin: 0;
      }

      .btn {
        width: 452px;
        height: 60px;
        padding: 0px 24px;
        background: #7765ff;
        border-radius: 5px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        line-height: 60px;
        margin-top: 24px;
        cursor: pointer;
      }

      .count-btn {
        width: 120px;
        height: 60px;
        border-radius: 8px;
        border: 1px solid #EFEFEF;
        line-height: 60px;
        font-size: 16px;
        font-weight: 400;
        color: #7765ff;
        text-align: center;
        cursor: pointer;
      }

      .text-box {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
      }
    }

    .del-box {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;

      img {
        width: 97px;
      }

      p {
        font-size: 16px;
        font-weight: 400;
        margin-top: 24px;
      }
    }
  }

  .flex-box {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background: fade(#000, 90%);
    display: flex;
    align-items: center;
    justify-content: center;

    .msg-box {
      position: relative;

      .err-img {
        width: 100px;
        margin-top: -100px;
      }

      .msg {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background: #fff;
        text-align: center;
        color: #999;
        font-size: 26px;
        padding: 50px;
        width: 380px;
        border-radius: 17px;

      }

      .close {
        position: absolute;
        right: 10px;
        top: 10px;
        width: 30px;
      }
    }
  }
}
</style>
